import React, { useEffect } from "react"; 
import "./App.css";
import "./style.css";
import { BrowserRouter as ReactRoutes } from "react-router-dom";
import AllRoutes from "./routes/routes";
import { refreshToken } from "./api/login";
import Cookies from "js-cookie";
import { NotificationProvider } from "./notification";
import "react-toastify/dist/ReactToastify.css";
import { useAxiosInstance } from "./api/config";
import Popup from "./components/AuthPopup";
import AutoLogout from "./layout/Autologout"; 
import { ZamzamErrorProvider } from "./pages/zamzam/context/ZamzamErrorContext";


const App: React.FC = () => {
  
  const { showPopup, popupMessage, setShowPopup, title } = useAxiosInstance();

  const refreshAcessToken = async () => {
    const token = Cookies.get("token");
    if (!token) {
      return
    }
    await refreshToken()
      .then((res) => {
        Cookies.set("token", res?.data?.access_token);
        Cookies.set("refresh_token", res?.data?.refresh_token);
      })
      .catch((error) => {
        console.log(error);
        const token= Cookies.get('token')
        if(token){
          Cookies.remove("refresh_token");
          Cookies.remove("token");
          window.location.href = "/";
        }else{
          Cookies.remove("refresh_token");
          Cookies.remove("token");
        }
      });
  };

  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      refreshAcessToken();
    }
    const intervalId = setInterval(refreshAcessToken, 400000);
    return () => clearInterval(intervalId);
  }, []);



  return (
    <NotificationProvider>
      <Popup
        isOpen={showPopup}
        title={title}
        setShowPopup={setShowPopup}
        >
        <p>{popupMessage}</p>
      </Popup>
      <ReactRoutes>
        <AutoLogout>
          <ZamzamErrorProvider>
            <AllRoutes />
          </ZamzamErrorProvider>
        </AutoLogout>
      </ReactRoutes>
    </NotificationProvider>
  );
};

export default App;
